import React, { useRef } from 'react';
import { useMobile } from '../../../hooks/useMobile';
import { formatNumber, getLineTotal } from '../../../utils';
import EllipsisTooltip from '../Tooltip/EllipsisTooltip';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  lineTotal: {
    color: theme.palette.brand.greenDark,
    fontWeight: 700,
  },
}));

const emptyValue = '0,000';

export default function LineTotal({ line }) {
  const classes = useStyles();
  const mobile = useMobile();
  const overflowElRef = useRef();
  const total = getLineTotal(line);
  const totalFormatted = formatNumber(total);
  return (
    <EllipsisTooltip
      arrow
      title={<Typography>{totalFormatted}</Typography>}
      placement="top"
      enterDelay={500}
      enterNextDelay={500}
      disableHoverListener={line?.edit}
      overflowElementRef={overflowElRef}
    >
      <Typography
        gutterBottom={!mobile}
        className={classes.lineTotal}
        ref={overflowElRef}
      >
        $ {totalFormatted || emptyValue}
      </Typography>
    </EllipsisTooltip>
  );
}
